import Table from '../../table.js';

namespace('IO.Views.IccPolicies', function (exports) {
  'use strict';

  var Index = Table.extend({
    dom: {
      DATATABLES: '#icc-datatable',
      MASKED_PASSWORD: '.mask-password',
    },

    opts: {
      ajaxSource: 'icc_policies.json',
      controller: 'icc_policies',
      fixed: false,
      filter: true,
      title: 'Click to edit',
    },

    render: function () {
      Table.prototype.render.call(this);
    },
  });

  exports.Index = Index;
});
